import { type HTMLAttributes } from 'react';

const baseStyles = 'block text-sm font-medium text-grey1';

export interface LabelProps extends HTMLAttributes<HTMLLabelElement> {
  htmlFor?: string;
}

export function Label({ htmlFor, children, className = '', ...rest }: LabelProps) {
  return (
    <label htmlFor={htmlFor} className={`${baseStyles} ${className}`} {...rest}>
      {children}
    </label>
  );
}